import { createAction, props } from '@ngrx/store';

import { Group } from '../../models/Group';

export enum GroupActionTypes {
  GetGroups = '[Feature Toggle Groups] Get Groups',
  GetGroupsSuccess = '[Feature Toggle Groups] Get Groups Success',

  Failure = '[Feature Toggle Groups] Failure',
}

export namespace GroupActions {
  export namespace GetGroups {
    export const request = createAction(GroupActionTypes.GetGroups);
    export const success = createAction(
      GroupActionTypes.GetGroupsSuccess,
      props<{ items: Group[] }>(),
    );
  }

  export const failure = createAction(
    GroupActionTypes.Failure,
    props<{ errorMessage: string }>(),
  );
}
